import React, { useState } from 'react';
import './AddClimaForm.css';
import { apiService } from '../../../services/ApiService';

const AddClimaForm = ({ obraId, onClose, onSuccess }) => {
  const [dados, setDados] = useState({
    condicao: 'ensolarado',
    temperatura: '',
    praticabilidade: 'praticavel',
    periodo: 'manhã',
    observacoes: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Opções para o dropdown de condição climática
  const condicoesClimaticas = [
    { id: 'ensolarado', nome: 'Ensolarado' },
    { id: 'nublado', nome: 'Nublado' },
    { id: 'chuvoso', nome: 'Chuvoso' },
    { id: 'tempestade', nome: 'Tempestade' },
    { id: 'nevando', nome: 'Nevando' },
    { id: 'ventoso', nome: 'Ventoso' },
    { id: 'parcialmente-nublado', nome: 'Parcialmente Nublado' }
  ];

  // Opções para o dropdown de praticabilidade
  const praticabilidades = [
    { id: 'praticavel', nome: 'Praticável' },
    { id: 'parcialmente-praticavel', nome: 'Parcialmente Praticável' },
    { id: 'nao-praticavel', nome: 'Não Praticável' }
  ];

  // Opções para o dropdown de período
  const periodos = [
    { id: 'manhã', nome: 'Manhã' },
    { id: 'tarde', nome: 'Tarde' },
    { id: 'noite', nome: 'Noite' },
    { id: 'dia-todo', nome: 'Dia Todo' }
  ];

  // Manipula alterações nos campos de texto
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDados(prevDados => ({
      ...prevDados,
      [name]: value
    }));
  };

  // Manipula o envio do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!dados.condicao) {
      setError('Por favor, selecione uma condição climática.');
      return;
    }

    if (!dados.temperatura) {
      setError('Por favor, informe a temperatura.');
      return;
    }

    try {
      setIsSubmitting(true);
      setError(null);
      
      // Enviar para a API usando o método addDiarioObraMedia
      const response = await apiService.addDiarioObraMedia(
        obraId,
        'clima',
        dados
      );

      if (response.success) {
        console.log("Condição climática adicionada com sucesso:", response);
        
        // Criar um objeto de registro
        const registroProcessado = response.registro || {
          id: response.id || Date.now().toString(),
          dados: dados,
          data: new Date().toISOString()
        };
        
        if (onSuccess) {
          onSuccess(registroProcessado);
        }
        onClose();
      } else {
        setError(response.error || 'Erro ao adicionar condição climática. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao adicionar condição climática:', error);
      setError('Ocorreu um erro ao adicionar a condição climática. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="clima-form-container">
      {error && (
        <div className="clima-form-error">
          <i className="fas fa-exclamation-circle"></i> {error}
        </div>
      )}

      <form className="clima-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="condicao">Condição Climática*</label>
          <select
            id="condicao"
            name="condicao"
            value={dados.condicao}
            onChange={handleInputChange}
            required
          >
            {condicoesClimaticas.map(condicao => (
              <option key={condicao.id} value={condicao.id}>
                {condicao.nome}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="temperatura">Temperatura (°C)*</label>
          <input
            type="number"
            id="temperatura"
            name="temperatura"
            value={dados.temperatura}
            onChange={handleInputChange}
            placeholder="Ex: 25"
            required
            step="0.1"
          />
        </div>

        <div className="form-group">
          <label htmlFor="praticabilidade">Praticabilidade*</label>
          <select
            id="praticabilidade"
            name="praticabilidade"
            value={dados.praticabilidade}
            onChange={handleInputChange}
            required
          >
            {praticabilidades.map(praticabilidade => (
              <option key={praticabilidade.id} value={praticabilidade.id}>
                {praticabilidade.nome}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="periodo">Período*</label>
          <select
            id="periodo"
            name="periodo"
            value={dados.periodo}
            onChange={handleInputChange}
            required
          >
            {periodos.map(periodo => (
              <option key={periodo.id} value={periodo.id}>
                {periodo.nome}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="observacoes">Observações (opcional)</label>
          <textarea
            id="observacoes"
            name="observacoes"
            value={dados.observacoes}
            onChange={handleInputChange}
            placeholder="Observações adicionais sobre as condições climáticas"
            rows="3"
          ></textarea>
        </div>

        <div className="clima-form-actions">
          <button 
            type="button" 
            className="btn-cancel" 
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancelar
          </button>
          <button 
            type="submit" 
            className="btn-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <div className="spinner-small"></div>
                <span>Enviando...</span>
              </>
            ) : (
              <>
                <i className="fas fa-save"></i>
                <span>Salvar</span>
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddClimaForm; 